import {
  DELETE_BATCH,
  DELETE_BATCH_FILE,
  DELETE_FTP_STORAGE,
  HIDE_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL,
  HIDE_ADD_EDIT_BATCH_ENDPOINT_MODAL,
  SET_ENTITIES_LIST,
  HIDE_ADD_EDIT_BATCH_FILE_MODAL,
  HIDE_ADD_EDIT_SHEET_CONFIG_MODAL,
  HIDE_ADD_EDIT_STORAGE_MODAL,
  HIDE_BATCH_FILE_LIST_MODAL,
  SET_BATCH_LIST,
  SET_FTP_STORAGE_LIST,
  SHOW_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL,
  SHOW_ADD_EDIT_BATCH_ENDPOINT_MODAL,
  SHOW_ADD_EDIT_BATCH_FILE_MODAL,
  SHOW_ADD_EDIT_SHEET_CONFIG_MODAL,
  SHOW_ADD_EDIT_STORAGE_MODAL,
  SHOW_BATCH_FILE_LIST_MODAL,
  UPSERT_BATCH,
  UPSERT_FTP_STORAGE,
  UPDATE_FORM_IN_STORE,
  RESET_FORM_IN_STORE,
  CHANGE_FILE_TYPE,
  REMOVE_ITEM_FROM_EXCEL_SHEET,
  ADD_ITEM_TO_SHEET_CONFIG,
  SET_ENTITY_TO_BATCH_FILE,
  UPDATE_BATCHFILES_LIST,
  EDIT_SHEET_CONFIG_ITEM,
} from './mutation-types';
import {axiosClient} from '../../../core/services/http.service';
import {uuid} from 'vue-uuid';

export async function getFtpStorageList({commit}) {
  const {
    success,
    body,
  } = await axiosClient.get('api/filemanipulationconfiguration/get-all-ftp-storage-configurations');

  if (success) commit(SET_FTP_STORAGE_LIST, body);
}

export async function upsertFtpStorage({commit}, {params, action}) {
  const response = await axiosClient.post('api/filemanipulationconfiguration/upsert-ftp-storage', params);

  if (response.success) {
    commit(UPSERT_FTP_STORAGE, {
      storage: params,
      action,
    });
  }

  return response;
}

export async function upsertBatch({commit}, {params, action}) {
  const response = await axiosClient.post('api/filemanipulationconfiguration/upsert-batch', params);

  if (response.success) {
    commit(UPSERT_BATCH, {
      batch: params,
      action,
    });
  }

  return response;
}

export async function deleteStorage({commit}, storage) {
  const response = await axiosClient.delete(`/api/filemanipulationconfiguration/delete-ftp-storage/${storage.name}`);

  if (response.success) {
    commit(DELETE_FTP_STORAGE, storage.name);
  }

  return response;
}

export async function upsertBatchFile({commit, dispatch}, {params}) {
  const response = await axiosClient.post('api/filemanipulationconfiguration/upsert-batch-file', params);
  return response;
}

export async function getBatchList({commit}) {
  const {success, body} = await axiosClient.get('/api/filemanipulationconfiguration/get-all-batches');

  if (success) {
    const map = {};
    const result = body.map(el => {
      if (el.batchFiles.length) {
        map[el.batchGuid] = el.batchFiles.map(entity => ({
          value: entity.entityGuid,
          text: entity.batchFileName,
        }));

        el.batchFiles = el.batchFiles.map(file => {
          if(file.batchFileType === 'excel') {
            file.batchFileConfig.config.sheetConfigs = file.batchFileConfig.config.sheetConfigs.map(el => {
              return {
                ...el,
                localGuid: uuid.v4(),
              };
            });
            return {
              ...file,
              ...file.config,
            };
          }
          return {
            ...file,
            ...file.config,
          };
        });
        return el;
      }
      return el;
    });

    commit(SET_ENTITIES_LIST, map);
    commit(SET_BATCH_LIST, result);
  }
}

export async function getBatchEndpointList({commit}) {
  const {success, body} = await axiosClient.get('/api/filemanipulationconfiguration/get-all-connector-batches');

  commit(SET_BATCH_LIST, success ? body : []);
}

// export async function getBatchFileList({commit}) {
//   return await axiosClient.get('/api/filemanipulationconfiguration/get-all-batch-files');
// }

export async function deleteBatch({commit}, batch) {
  const response = await axiosClient.delete(`/api/filemanipulationconfiguration/delete-batch/${batch.batchGuid}`);

  if (response.success) {
    commit(DELETE_BATCH, batch.batchGuid);
  }

  return response;
}

export async function deleteConnectorBatch({commit}, batch) {
  const response = await axiosClient.delete(`/api/filemanipulationconfiguration/delete-connector-batch/${batch.batchId}`);

  if (response.success) commit(DELETE_BATCH, batch.batchId);

  return response;
}

export async function deleteBatchFile({commit}, batchFile) {
  const response = await axiosClient.delete(`api/filemanipulationconfiguration/delete-batch-file/${batchFile.batchFileGuid}`);

  if (response.success) {
    commit(DELETE_BATCH_FILE, batchFile);
  }

  return response;
}

export async function upsertConnectorBatch({commit}, params) {
  const response = await axiosClient.post('/api/filemanipulationconfiguration/upsert-connector-batch', params.data);

  if (response.success) {
    commit(UPSERT_BATCH, {
      batch: response.body,
      action: params.action,
    });
  }

  return response;
}

export function showAddEditModal({commit}, item = null) {
  commit(SHOW_ADD_EDIT_STORAGE_MODAL, item);
}

export function hideAddEditModal({commit}) {
  commit(HIDE_ADD_EDIT_STORAGE_MODAL);
}

export function showBatchFileListModal({commit}, batch) {
  commit(SHOW_BATCH_FILE_LIST_MODAL, batch);
}

export function hideBatchFileListModal({commit}) {
  commit(HIDE_BATCH_FILE_LIST_MODAL);
}

export function showAddEditBatchFileModal({commit}, params) {
  commit(SHOW_ADD_EDIT_BATCH_FILE_MODAL, params);
}

export function hideAddEditBatchFileModal({commit}) {
  commit(HIDE_ADD_EDIT_BATCH_FILE_MODAL);
}

export function showAddEditSheetConfigModal({commit}, item) {
  commit(SHOW_ADD_EDIT_SHEET_CONFIG_MODAL, item);
}

export function hideAddEditSheetConfigModal({commit}) {
  commit(HIDE_ADD_EDIT_SHEET_CONFIG_MODAL);
}

export function showAddEditBatchEndpointModal({commit}, item = null) {
  commit(SHOW_ADD_EDIT_BATCH_ENDPOINT_MODAL, item);
}

export function hideAddEditBatchEndpointModal({commit}) {
  commit(HIDE_ADD_EDIT_BATCH_ENDPOINT_MODAL);
}

export function showAddEditBatchEndpointChildModal({commit}, params) {
  commit(SHOW_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL, params);
}

export function hideAddEditBatchEndpointChildModal({commit}) {
  commit(HIDE_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL);
}


export function updateFormInStore({commit}, payload) {
  commit(UPDATE_FORM_IN_STORE, payload);
};

export const resetFormInStore = ({commit}) => {
  commit(RESET_FORM_IN_STORE);
};

export const changeFileType = ({commit}, payload) => {
  commit(CHANGE_FILE_TYPE, payload);
};

export const removeItemFromExcelSheet = ({commit}, payload) => {
  commit(REMOVE_ITEM_FROM_EXCEL_SHEET, payload);
};

export const addItemToSheetConfig = ({commit}, payload) => {
  commit(ADD_ITEM_TO_SHEET_CONFIG, payload);
};

export const editSheetConfigItem = ({commit}, payload) => {
  commit(EDIT_SHEET_CONFIG_ITEM, payload);
};
export const setEntityToBatchFile = ({commit}, payload) => {
  commit(SET_ENTITY_TO_BATCH_FILE, payload);
};

export const  updateBatchFilesList = ({commit}, payload) => {
  commit(UPDATE_BATCHFILES_LIST, payload);
};